import { Box, Container } from '@mui/material';
import { FC, ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

export const PageContainer: FC<Props> = ({ children }) => {
  return (
    <Box
      sx={{
        backgroundColor: 'background.default',
        flexGrow: 1,
      }}>
      <Container
        maxWidth="xl"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
        }}>
        {children}
      </Container>
    </Box>
  );
};
